/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { Placeholder } from 'sarsaparilla';

/** Find a Campsite / View Map button row (matches `campground-page-v3-buttons` on the live page). */
export default function CampgroundPageV3PrimaryActionsPlaceholder() {
    return (
        <div className="campground-page-v3-buttons" aria-hidden="true">
            <Placeholder height="44px" width="100%" />
            <Placeholder height="44px" width="100%" />
        </div>
    );
}
